import { render } from "./BarcodeForm.vue?vue&type=template&id=30858f9b&ts=true"
import script from "./BarcodeForm.vue?vue&type=script&lang=ts"
export * from "./BarcodeForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__